import axios from "axios";
import { API_URL } from "../constant";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const parentsConsentService = {
  list: async (params = {}) => {
    const response = await api.get("/superadmin/parents-consent", { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/superadmin/parents-consent/${id}`);
    return response.data;
  },

  review: async (id, payload) => {
    const response = await api.patch(`/superadmin/parents-consent/${id}/review`, payload);
    return response.data;
  },
};
